<template>
  <div class="p-[24px] flex flex-col items-end justify-end">
    <div
      v-if="errorMessage"
      class="flex grow w-full rounded-lg bg-[#FFF2E2] px-3.5 py-2.5 gap-2.5 items-center justify-start border-[1px] border-[#FBA63C] mb-[20px]"
    >
      <img
        src="https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg"
        alt="info-circle"
      >
      <div class="text-[#333]">
        {{ errorMessage }}
      </div>
    </div>
    <div class="flex items-end justify-end gap-[6px] text-[#0A0A0A] text-[14px] font-medium mb-[24px]">
      <div class="grow text-right">
        <p>Total Order</p>
        <p>Total Biaya Fulfillment</p>
      </div>
      <div>
        <p>: {{ totalOrder }}</p>
        <p>: {{ totalFulfillmentFee | rupiah }}</p>
      </div>
    </div>
    <Button
      variant="primary"
      class="text-[14px] flex items-center justify-center gap-[8px]"
      :disabled="!isAllowSubmit || isOnSubmit"
      @click="handleSubmitBulkUpload"
    >
      <b-spinner
        v-if="isOnSubmit"
        small
      />
      {{ isOnSubmit ? 'Memproses...' : 'Ajukan Pickup' }}
    </Button>
  </div>
</template>

<script>
import { Button } from '@/@core/components/ui'
/**
 * Packing Form Footer to show the total order and fulfillment fee
 * and the submit button
 */
export default {
  components: {
    Button,
  },
  props: {
    totalOrder: {
      type: Number,
      default: 0,
    },
    totalFulfillmentFee: {
      type: Number,
      default: 0,
    },
    isAllowSubmit: {
      type: Boolean,
      default: false,
    },
    isOnSubmit: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  methods: {
    /**
     * Handles the submission of content.
     */
    async handleSubmitBulkUpload() {
      this.$emit('submit-content')
    },
  },
}
</script>
